import { z } from 'zod'

export const createShareSchema = z.object({
  privacy: z.enum(['public', 'private']),
  password: z.string().min(6).optional(),
  expiresAt: z.string().datetime().optional(),
  allowComments: z.boolean().optional()
})

export const accessPrivateShareSchema = z.object({
  password: z.string()
})
